/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Translation_Import_Button_Group_LabelInputs */

const en_ai_translation_import_button_group_label = /** @type {(inputs: Ai_Translation_Import_Button_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Button group with nested dropdown`)
};

const fr_ai_translation_import_button_group_label = /** @type {(inputs: Ai_Translation_Import_Button_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe de boutons avec menu deroulant imbrique`)
};

const de_ai_translation_import_button_group_label = /** @type {(inputs: Ai_Translation_Import_Button_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schaltflächengruppe mit verschachteltem Dropdown-Menü`)
};

const it_ai_translation_import_button_group_label = /** @type {(inputs: Ai_Translation_Import_Button_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di pulsanti con menu a discesa annidato`)
};

const ru_ai_translation_import_button_group_label = /** @type {(inputs: Ai_Translation_Import_Button_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа кнопок с вложенным выпадающим списком`)
};

const es_ai_translation_import_button_group_label = /** @type {(inputs: Ai_Translation_Import_Button_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de botones con menú desplegable anidado`)
};

const zh_cn2_ai_translation_import_button_group_label = /** @type {(inputs: Ai_Translation_Import_Button_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带有嵌套下拉菜单的按钮组`)
};

const ja_ai_translation_import_button_group_label = /** @type {(inputs: Ai_Translation_Import_Button_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストされたドロップダウンを持つボタングループ`)
};

const hi_ai_translation_import_button_group_label = /** @type {(inputs: Ai_Translation_Import_Button_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नेस्टेड ड्रॉपडाउन के साथ बटन समूह`)
};

const pt_pt2_ai_translation_import_button_group_label = /** @type {(inputs: Ai_Translation_Import_Button_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de botões com lista suspensa aninhada`)
};

/**
* | output |
* | --- |
* | "Button group with nested dropdown" |
*
* @param {Ai_Translation_Import_Button_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ai_translation_import_button_group_label = /** @type {((inputs?: Ai_Translation_Import_Button_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Translation_Import_Button_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ai_translation_import_button_group_label(inputs)
	if (locale === "de") return de_ai_translation_import_button_group_label(inputs)
	if (locale === "it") return it_ai_translation_import_button_group_label(inputs)
	if (locale === "ru") return ru_ai_translation_import_button_group_label(inputs)
	if (locale === "es") return es_ai_translation_import_button_group_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ai_translation_import_button_group_label(inputs)
	if (locale === "ja") return ja_ai_translation_import_button_group_label(inputs)
	if (locale === "hi") return hi_ai_translation_import_button_group_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ai_translation_import_button_group_label(inputs)
	return en_ai_translation_import_button_group_label(inputs)
});